import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
import { useLocalObservable } from "mobx-react-lite";
const createGlobalConfigStore = (initialValues)=>{
    return {
        defaultPageLimit: initialValues.defaultPageLimit || 10,
        defaultPageMaxLimit: initialValues.defaultPageMaxLimit || 50
    };
};
export const GlobalConfigContext = /*#__PURE__*/ createContext(null);
export const GlobalConfigProvider = (param)=>{
    let { children , initialValues ={}  } = param;
    const store = useLocalObservable(()=>createGlobalConfigStore(initialValues));
    return /*#__PURE__*/ _jsx(GlobalConfigContext.Provider, {
        value: store,
        children: children
    });
};
export const useGlobalConfigStore = ()=>{
    const store = useContext(GlobalConfigContext);
    if (!store) {
        // this is especially useful in TypeScript so you don't need to be checking for null all the time
        throw new Error("useStore must be used within a StoreProvider.");
    }
    return store;
};
